<template>
  <div v-if="value !== 0">
    <v-dialog v-model="dialog" max-width="1000px" scrollable>
      <template v-slot:activator="{ on }">
        <a @click="getTotal" v-on="on">{{ value | localeString(value % 1 ? 2 : 0) }}</a>
      </template>
      <v-card v-if="dialog">
        <v-card-title>
          <span ref="listTitle" class="pa-1 table-card-title">
            <span v-if="nomeLista">{{ nomeLista }} - </span>Categoria: {{ nomeCategoria }}
          </span>
          <v-spacer />
          <v-menu bottom origin="center center" transition="scale-transition">
            <template v-slot:activator="{ on }">
              <mf-button type="icon" icon="more_vert" color="cinza-0" :loading="csv.loading" v-on:click.native="on.click" />
            </template>

            <v-list>
              <v-list-item @click="exportarCsv">
                <v-list-item-title>Exportar CSV</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-card-title>
        <v-card-text>
          <v-data-table
            :headers="headers"
            :items="clientes"
            :options.sync="options"
            :server-items-length="total"
            :loading="loading"
            :items-per-page-options="rowsPerPageArray"
          >
            <template v-slot:item="{ item }">
              <tr>
                <td>
                  <router-link class="link" :to="{ path: `/clientes/detalhes-cliente/${item['COD_ID_CLIENTE']}` }">{{ item['NOM_NOME'] }}</router-link>
                </td>
                <td>{{ item['DES_FONE_1'] | telefone }}</td>
                <td>{{ item['DES_FONE_2'] | telefone }}</td>
                <td>{{ item['DES_EMAIL'] }}</td>
              </tr>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>

  <div v-else>
    <span>{{ value }}</span>
  </div>
</template>

<script>
import { assertArray } from '@/config/helpers.js'
import { listaClientesPelaCompraCSV } from '@/services/kpis.js'
import { mapActions, mapState } from 'vuex'
import { DateTime } from 'luxon'

export default {
  props: {
    categoriaProduto: [Number, String],
    categoriaGenero: String,
    categoriaFaixaEtaria: [Number, String],
    value: Number,
    nomeLista: String,
    nomeCategoria: String,
  },
  data() {
    return {
      csv: {
        loading: false,
      },
      dialog: false,
      search: '',
      clientes: [],
      loading: true,
      options: {},
      rowsPerPageArray: [10, 25, 50, 100, { text: 'Todos', value: '' }],
      headers: [
        {
          text: 'Cliente',
          width: '25%',
          sortable: false,
        },
        {
          text: 'Celular',
          width: '25%',
          sortable: false,
        },
        {
          text: 'Telefone',
          width: '25%',
          sortable: false,
        },
        {
          text: 'E-mail',
          width: '25%',
          sortable: false,
        },
      ],
      total: null,
    }
  },
  computed: {
    ...mapState({ stateFilters: (state) => state.filters }),
    filter() {
      return {
        date: this.stateFilters.data,
        unidades: this.stateFilters.unitsConfiguration,
        tipo_pessoa: this.stateFilters.pessoa,
        categoria_cliente: this.stateFilters.cliente,
        fidelidade: this.stateFilters.fidelidade,
        categoria_produto: this.categoriaProduto,
        genero: this.categoriaGenero,
        faixa_etaria: this.categoriaFaixaEtaria,
        segmentos: this.stateFilters.segments,
      }
    },
  },
  watch: {
    options: {
      handler() {
        this.getDataFromApi().then((clientes) => {
          this.clientes = assertArray(clientes)
        })
      },
      deep: true,
    },
  },

  methods: {
    ...mapActions(['listaClientesPelaCompra', 'clientesClientesAtivos']),
    getTotal() {
      this.listaClientesPelaCompra({ data_type: 'size', ...this.filter }).then((quantidade) => {
        this.total = quantidade['NUM_SIZE']
      })
    },
    getDataFromApi() {
      this.loading = true
      return new Promise((resolve, reject) => {
        const { page, itemsPerPage } = this.options
        this.listaClientesPelaCompra({ page: page, page_size: itemsPerPage, ...this.filter }).then((clientes) => {
          this.loading = false
          resolve(clientes)
        })
      })
    },
    exportarCsv() {
      this.csv.loading = true
      let dateNow = DateTime.now().toFormat('dd-MM-yy')
      listaClientesPelaCompraCSV({ send_file: true, ...this.filter }, `clientes-selecionados-${dateNow}`).then(() => {
        this.csv.loading = false
      })
    },
  },
}
</script>
